import useProductSummary from "../../../../hooks/use-product-summary";
import StatCard from "../../../../components/StatCard";
import { StatSummary } from "../../../../components/StatSummary";
import { Battery2BarIcon, BatteryAlertIcon, HourglassBottomIcon, LocalGroceryStoreIcon } from "../../../../shared/icons";

const ProductSummary = () => {
    const productSummary = useProductSummary();

    return (
        <div>
            {productSummary &&
                <>
                    <StatSummary>
                        <StatCard title="Total Products" value={productSummary?.totalProducts.toString()} icon={LocalGroceryStoreIcon} />
                        <StatCard title="Low Stock Products" value={productSummary?.lowStockProducts.toString()} icon={Battery2BarIcon} />
                        <StatCard title="Out of Stock Products" value={productSummary?.outOfStockProducts.toString()} icon={BatteryAlertIcon} />
                        <StatCard title="Expired Products" value={productSummary?.expiredProducts.toString()} icon={HourglassBottomIcon} />
                    </StatSummary>                    
                </>
            }
        </div>
    )
}

export default ProductSummary;